

import sensors from 'sa-sdk-javascript/sensorsdata.es6.min.js'

const isShow = import.meta.env.VITE_SHOW_UPLOAD_LOG

let severUrl = import.meta.env.VITE_SHENCE_SEVER_URL

let webUrl = import.meta.env.VITE_SHENCE_WEB_URL


export const analysis = {
  // sensor对象
  instance: null,
  // sensor初始化的方法
  instantiate: function () {
    // 目前暂时是通过从父容器中获取
    this.instance = sensors
  },
  // sensor记录验证主要方法，事件以及options
  customeTrack: function ({ elementName, elementContent }) {
    this.instance && this.instance.track('$WebClick', this.addPublicProperties({
      $element_name: elementName,
      $element_content: elementContent
    }))
  },
  // sensor记录验证主要方法，事件以及options
  track: function (eventName, customProperties = {}) {
    let types = eventName.split('_')
    this.instance && this.instance.track('$WebClick', this.addPublicProperties({
      $element_name: eventName,
      $element_content: types[1],
      ...customProperties
    }))
  },
  // 添加公共属性
  addPublicProperties: function (options) {
    let props = options || {}

    if (!props.sys_product_name) {
      props.sys_product_name = 'alpha'
    }

    if (!props.sys_platform) {
      props.sys_platform = 'web'
    }

    
    return props
  },
  // sensor自动添加路由的pageView
  routeTrack: function (route) {
    this.instance && this.instance.quick('autoTrack', {
      // 根据路由配置对路径来判断采集的名字
      customTitle: route.name || document.title
    })
  },
  login: function () {
    this.instance && this.instance.login()
  },
  setProfile: function () {
    this.instance && this.instance.setProfile()
  },
  quick: function (eventName, options) {
    this.instance && this.instance.quick(eventName, options)
  }
}

export function initMonitor(registCustomParamsFn) {

  return new Promise((resolve) => {
    let para = {
      name: 'alpha_sa',
      server_url:severUrl,
      web_url: webUrl,
      is_single_page: true,
      corss_subdomain: false, //访问 tieba.baidu.com 和 zhidao.baidu.com 的用户会被认为是两个不同的用户
      show_log: isShow == '1' ? true:false,
      heatmap: {
        loadTimeout: 3000,
        collect_url: function () {
          return true
        }
      }
    }
  
  
    sensors.init(para)

    if (typeof registCustomParamsFn === 'function') {
      sensors.register({
        ...registCustomParamsFn()
      })
    }
   
    sensors.quick('autoTrack') //用于采集 $pageview 事件。

    // 初始化神策数据对象
    analysis.instantiate()

  })
}

export function createMonitor(initFn,registCustomParamsFn) {
  if (initFn instanceof Promise) {
    return initFn.then(res => {
      initMonitor(registCustomParamsFn)
    }) // 如果传入的函数是 Promise，直接返回该 Promise
  }

  return new Promise((resolve) => {
    const result = initFn()
    resolve(result) // 否则，将函数的返回值作为 Promise 的结果
  }).then(res => {
    initMonitor(registCustomParamsFn)
  })
}